var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVkHrTekLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 72,
    viewBox: "0 0 259 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.8802 24.0121L79.879 49.2121H74.0698L63.105 24.0121H69.4588L77.1923 42.0121L85.0347 24.0121H90.8802Z",
    fill: "#090909"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.958 39.3121L98.5451 42.8401V49.2121H92.6996V24.0121H98.5451V35.7841L109.8 24.0121H116.336L105.807 35.2441L116.953 49.2121H110.091L101.958 39.3121Z",
    fill: "#090909"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M152.562 24.0121V49.2121H146.68V38.8801H135.135V49.2121H129.253V24.0121H135.135V33.9481H146.68V24.0121H152.562Z",
    fill: "#090909"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M174.466 49.2121L169.564 42.1921H164.155V49.2121H158.273V24.0121H169.274C171.525 24.0121 173.473 24.3841 175.119 25.1281C176.79 25.8721 178.072 26.9281 178.968 28.2961C179.864 29.6641 180.311 31.2841 180.311 33.1561C180.311 35.0281 179.851 36.6481 178.932 38.0161C178.036 39.3601 176.753 40.3921 175.083 41.1121L180.783 49.2121H174.466ZM174.357 33.1561C174.357 31.7401 173.897 30.6601 172.977 29.9161C172.057 29.1481 170.714 28.7641 168.947 28.7641H164.155V37.5481H168.947C170.714 37.5481 172.057 37.1641 172.977 36.3961C173.897 35.6281 174.357 34.5481 174.357 33.1561Z",
    fill: "#090909"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M199.913 28.7641H191.78V24.0121H213.928V28.7641H205.795V49.2121H199.913V28.7641Z",
    fill: "#090909"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M233.539 39.6001C233.539 39.6721 233.503 40.1761 233.43 41.1121H218.653C218.919 42.3121 219.549 43.2601 220.541 43.9561C221.534 44.6521 222.768 45.0001 224.244 45.0001C225.261 45.0001 226.157 44.8561 226.931 44.5681C227.73 44.2561 228.468 43.7761 229.146 43.1281L232.159 46.3681C230.32 48.4561 227.633 49.5001 224.099 49.5001C221.897 49.5001 219.948 49.0801 218.254 48.2401C216.559 47.3761 215.252 46.1881 214.333 44.6761C213.413 43.1641 212.953 41.4481 212.953 39.5281C212.953 37.6321 213.401 35.9281 214.296 34.4161C215.216 32.8801 216.463 31.6921 218.036 30.8521C219.633 29.9881 221.413 29.5561 223.373 29.5561C225.285 29.5561 227.016 29.9641 228.565 30.7801C230.114 31.5961 231.324 32.7721 232.196 34.3081C233.091 35.8201 233.539 37.5841 233.539 39.6001ZM223.409 33.8041C222.127 33.8041 221.049 34.1641 220.178 34.8841C219.307 35.6041 218.774 36.5881 218.581 37.8361H228.202C228.008 36.6121 227.476 35.6401 226.604 34.9201C225.733 34.1761 224.668 33.8041 223.409 33.8041Z",
    fill: "#090909"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M245.395 41.6161L242.671 44.2801V49.2121H237.007V22.5001H242.671V37.6201L250.95 29.8441H257.703L249.57 38.0521L258.429 49.2121H251.567L245.395 41.6161Z",
    fill: "#090909"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19850_266248)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19850_266248",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 11,
    width: 49,
    height: 49
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 35.0011C0 24.156 0 18.736 3.37661 15.3703C6.75322 12.0045 12.1769 11.9993 23.0401 11.9993H25.0449C35.9028 11.9993 41.3318 11.9993 44.7084 15.3703C48.085 18.7413 48.0797 24.156 48.0797 35.0011V37.0027C48.0797 47.8426 48.0797 53.2625 44.7084 56.6335C41.3371 60.0045 35.9028 59.9993 25.0449 59.9993H23.0401C12.1769 59.9993 6.74794 59.9993 3.37661 56.6335C0.00527607 53.2678 0 47.8426 0 37.0027V35.0011Z",
    fill: "#212121"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19850_266248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 35.0011C0 24.156 0 18.736 3.37661 15.3703C6.75322 12.0045 12.1769 11.9993 23.0401 11.9993H25.0449C35.9028 11.9993 41.3318 11.9993 44.7084 15.3703C48.085 18.7413 48.0797 24.156 48.0797 35.0011V37.0027C48.0797 47.8426 48.0797 53.2625 44.7084 56.6335C41.3371 60.0045 35.9028 59.9993 25.0449 59.9993H23.0401C12.1769 59.9993 6.74794 59.9993 3.37661 56.6335C0.00527607 53.2678 0 47.8426 0 37.0027V35.0011Z",
    fill: "#0077FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0797 11.9993H15.0249V29.9993H30.0498V44.9993H48.0797V11.9993Z",
    fill: "#00D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01522 50.9992H23.1011V36.9367H9.01522L9.01522 50.9992Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19850_266248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.0797,
    height: 48,
    fill: "white",
    transform: "translate(0 12.0005)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkHrTekLogo);
export default __webpack_public_path__ + "static/media/vk-hr-tek-logo.bfa65707455439c6e4dfe770b685015e.svg";
export { ForwardRef as ReactComponent };